import { Component, Inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { LoaderComponent } from '../../loader/loader.component';
import { TranslationDirective } from '../../translata-modal/translation.directive';
import { TranslateModule } from '@ngx-translate/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-download-dialog-box',
  templateUrl: './download-dialog-box.component.html',
  styleUrls: ['./download-dialog-box.component.scss'],
  imports: [NgIf, LoaderComponent, TranslationDirective, TranslateModule],
})
export class DownloadDialogBoxComponent {
  isDownloading: boolean;
  constructor(
    private dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true;
    this.isDownloading = this.data.isDownloading;
  }
}
